import { createFileRoute } from "@tanstack/react-router";
import { NotificationSettingsPage } from "@/components/notifications/notification-settings-page";

export const Route = createFileRoute("/admin/_layout/notification-settings")({
  component: () => <NotificationSettingsPage />,
});
